import { IoMdMore } from "react-icons/io";
import { LuUser } from "react-icons/lu";
import { GoDotFill } from "react-icons/go";
import { useNavigate } from "react-router-dom";
import { useStateSetter } from "../../../hooks/statehooks/UseStateSettersHook";
import EmployeeDetailed from "./EmployeeDetailed";
import { isButtonElement } from "react-router-dom/dist/dom";
import { useDeptHook } from "../../../hooks/useDeptHook";

export default ({ item }: any) => {
   const { setSelecteduser } = useStateSetter();
  const {AllOrgDepts}=useDeptHook()
  const { setSidebarRenderView, setselectedEmpl } = useStateSetter();

  return (
    <div
      onClick={() => {
        setselectedEmpl(item);
        console.log(item);
        setSidebarRenderView(<EmployeeDetailed id={item.id} />);
      }}

      className="bg-whit shadow-sm border border-gray-200 overflow-x-hidden rounded-[10px] flex  py-4  px-1 justify-between items-center"
    >
      <div className="flex">
        <LuUser
          size={45}
          className="bg-[#EAECF5] p-3 text-textbg ml-2 rounded-full "
        />
        <div className=" px-2">
          <p className="font-semibold text-xs cursor-pointer">
            {item.firstName} {item.lastName}
          </p>
          <p className="font-light text-xs cursor-pointer">
            
            {item.workEmail} 
          </p>
          <div>
            <p className="inline text-xs bg-faintBlue p-1 rounded">
              Dept. {AllOrgDepts.filter((k)=>k.id==item.deptID)[0]?.deptName}
            </p> 
            <p className="font-light text-xs cursor-pointer inline">
              <GoDotFill className="inline text-green-600" /> Active
            </p>
          </div>
        </div>
      </div>

      <IoMdMore size={20} className="text-textbg " />
    </div>
  );
};
